import React, {useState} from 'react';

import {MediaQuery} from '@optimaxdev/design-system';
import classNames from 'classnames';
import {useMediaQuery} from 'react-responsive';

import {PayOverTimeLocations} from 'constants/payOverTime';
import {QuestionMark} from 'desktop/components/helpers/icons/questionMark/questionMark';

import {sendAnalytics} from './analytics';
import {PayOverTimePopupConnected} from './payOverTimePopup/payOverTimePopup';

import s from './payOverTime.scss';

export type PropsType = {
    location: PayOverTimeLocations;
};

/**
 * PayOverTime with Klarna, Paypal or Affirm
 */
export const PayOverTime: React.FC<PropsType> = ({location}) => {
    const [isOpened, setIsOpened] = useState(false);
    const isSmallScreen = useMediaQuery(MediaQuery.sm);

    const onOpenPopupHandler = () => {
        sendAnalytics(location);
        setIsOpened(true);
    };

    const computedStyles = {
        cart: s.cart,
        cartRebate: s.cartRebate,
        checkoutRebate: s.checkoutRebate,
    };

    const renderButton = () => (
        <button className={s.questionMarkBtn} onClick={onOpenPopupHandler} type="button">
            <QuestionMark color="dustSpruceGrey" size="small" />
        </button>
    );

    return (
        <>
            <div className={s.container}>
                <div className={classNames(s.common, computedStyles[location])}>
                    {isSmallScreen && location === PayOverTimeLocations.CART_REBATE ? (
                        <span>
                            Pay over time with <b>Klarna</b> and more
                        </span>
                    ) : (
                        <span>
                            Pay over time with <b>Klarna, PayPal</b> or&nbsp;<b>Affirm</b>
                        </span>
                    )}
                    {renderButton()}
                </div>
            </div>
            <PayOverTimePopupConnected
                closePopup={() => setIsOpened(false)}
                isOpened={isOpened}
                location={location}
            />
        </>
    );
};
